import React, { Component } from 'react'
import i18n from '../i18n.json'
import validator from 'validator'

class Sign extends Component {
  constructor(props) {
    super(props)
    let display = true
    if (props.attemptedAction === 'getPurchases') display = false
    this.state = {
      name: null,
      email: null,
      password: null,
      displaySignup: display
    }
  }

  handleChange(evt) {
    let { name, value } = evt.target

    this.setState({
      [name]: value
    })
  }

  handleSignup(evt) {
    evt.preventDefault()
    evt.stopPropagation()
    this.btnSignUp.setAttribute("disabled", "disabled")

    let { name, email, password } = this.state
    let { selectedLanguage } = this.props.newLogo.userPrefs

    // Check if the user filled the form
    if (!name) {
      this.btnSignUp.removeAttribute("disabled")
      return this.setState({ error: i18n[selectedLanguage]['sign-error-name'] })
    }
    if (!email) {
      this.btnSignUp.removeAttribute("disabled")
      return this.setState({ error: i18n[selectedLanguage]["sign-error-email"] })
    }
    if (!password) {
      this.btnSignUp.removeAttribute("disabled")
      return this.setState({ error: i18n[selectedLanguage]["sign-error-password"] })
    }
    // Check if the user's info is valid
    if (!(validator.isEmail(email))) {
      this.btnSignUp.removeAttribute("disabled")
      return this.setState({ error: i18n[selectedLanguage]["sign-error-invalid-email"] })
    }
    if (validator.trim(validator.escape(password)).length < 6) {
      this.btnSignUp.removeAttribute("disabled")
      return this.setState({ error:i18n[selectedLanguage][ "sign-error-invalid-password"] })
    }

    this.setState({
      name: validator.trim(validator.escape(name)),
      email: validator.normalizeEmail(email, { all_lowercase: true }),
      password: validator.trim(validator.escape(password))
    })
    this.props.createUser({
      name: validator.trim(validator.escape(name)),
      email: validator.normalizeEmail(email, { all_lowercase: true }),
      password: validator.trim(validator.escape(password)),
      language: this.props.newLogo.userPrefs.selectedLanguage,
      attemptedAction: this.props.attemptedAction,
      userPrefs: this.props.newLogo.userPrefs,
      availableColorPalettes: this.props.newLogo.availableColorPalettes,
      availableTypefaces: this.props.newLogo.availableTypefaces
    })
    .then((user) => {
      // console.log('USER', user)
    })
    .catch((error) => {
      this.btnSignUp.removeAttribute("disabled")
      if (error === "Wrong password" && selectedLanguage === 'pt')
        return this.setState({ error: "Usuário já é cadastrado mas a senha está incorreta"})
        // this.setState({ error: error})
      if (selectedLanguage === 'pt')
        return this.setState({ error: "Um erro foi encontrado, por favor tente novamente ou entre em contato"})
      return this.setState({ error: "An error was found, please try again or send us an email"})
    })
  }

  handleSignin(evt) {
    evt.preventDefault()
    evt.stopPropagation()
    this.btnSignIn.setAttribute("disabled", "disabled")

    let { email, password } = this.state
    let { selectedLanguage } = this.props.newLogo.userPrefs
    if (!email) {
      this.btnSignIn.removeAttribute("disabled")
      return this.setState({ error: i18n[selectedLanguage]['sign-error-email'] })
    }
    if (!password) {
      this.btnSignIn.removeAttribute("disabled")
      return this.setState({ error: i18n[selectedLanguage]['sign-error-password'] })
    }
    // Check if the user's info is valid
    if (!(validator.isEmail(email))) {
      this.btnSignIn.removeAttribute("disabled")
      return this.setState({ error: i18n[selectedLanguage]["sign-error-invalid-email"] })
    }
    if (validator.trim(validator.escape(password)).length < 6) {
      this.btnSignIn.removeAttribute("disabled")
      return this.setState({ error: i18n[selectedLanguage]["sign-error-invalid-password"] })
    }

    this.setState({
      email: validator.normalizeEmail(email, { all_lowercase: true }),
      password: validator.trim(validator.escape(password))
    })
    this.props.signinUser({
      email: validator.normalizeEmail(email, { all_lowercase: true }),
      password: validator.trim(validator.escape(password)),
      attemptedAction: this.props.attemptedAction,
      userPrefs: this.props.newLogo.userPrefs,
      availableColorPalettes: this.props.newLogo.availableColorPalettes,
      availableTypefaces: this.props.newLogo.availableTypefaces
    })
    .then((user) => {
      // console.log('USER', user)
    })
    .catch((error) => {
      this.btnSignIn.removeAttribute("disabled")
      if (error === "User was not found" && selectedLanguage === 'pt')
        return this.setState({ error: "Usuário não encontrado"})
      if (error === "Wrong password, try again" && selectedLanguage === 'pt')
        return this.setState({ error: "Senha incorreta, tente novamente"})
      if (selectedLanguage === 'pt')
        return this.setState({ error: "Um erro foi encontrado, por favor tente novamente ou entre em contato"})
      return this.setState({ error: "An error was found, please try again or send us an email"})
    })
  }

  toggleForm(evt) {
    evt.preventDefault()
    this.setState({
      displaySignup: !this.state.displaySignup
    })
  }

  renderSignupForm() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    return (
      <div>
        {
          this.state.error
          ?
          <div>
            <h4> { this.state.error } </h4>
          </div>
          :
          null
        }
       <form className="sign-form" onSubmit={ this.handleSignup.bind(this) }>
         <input type="text" name="name" value={this.state.name || ""} onChange={ this.handleChange.bind(this) } placeholder={i18n[selectedLanguage]['full-name']}/>
         <input type="text" name="email" value={this.state.email || ""} onChange={ this.handleChange.bind(this) } placeholder="Email" />
         <input type="password" name="password" value={this.state.password || ""} onChange={ this.handleChange.bind(this) } placeholder={i18n[selectedLanguage]['password']}/>
         <input type="submit" ref={btnSignUp => { this.btnSignUp = btnSignUp }} id="sign-submit" value={i18n[selectedLanguage]['sign-up']}/>
       </form>

       <a id="sign-alt" href="/signin" onClick={ this.toggleForm.bind(this) }>{i18n[selectedLanguage]['sign-already-registered']}</a>
      </div>
    )
  }

  renderSigninForm() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    return (
      <div>
        {
          this.state.error
          ?
          <div>
            <h4> { this.state.error } </h4>
          </div>
          :
          null
        }
       <form className="sign-form" onSubmit={ this.handleSignin.bind(this) }>
         <input type="text" name="email" value={this.state.email || ""} onChange={ this.handleChange.bind(this) } placeholder="Email" />
         <input type="password" name="password" value={this.state.password || ""} onChange={ this.handleChange.bind(this) } placeholder={i18n[selectedLanguage]['password']}/>
         <input type="submit" ref={btnSignIn => { this.btnSignIn = btnSignIn }} id="sign-submit" value={i18n[selectedLanguage]['sign-in']}/>
       </form>

       <a id="sign-alt" href="/signin" onClick={ this.toggleForm.bind(this) }>{i18n[selectedLanguage]['sign-not-registered']}</a>
      </div>
    )
  }

  renderForm() {
     if (this.state.displaySignup) {
       return this.renderSignupForm()
     } else {
       return this.renderSigninForm()
     }
  }

  render() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    return (
      <div className="modal-box">
          { (this.props.attemptedAction === 'getPurchases')
          ?
            <p className="main-text">{ i18n[selectedLanguage]['step-loading-title-direct'] }</p>
          :
            <p className="main-text">{ i18n[selectedLanguage]['step-loading-title'] }</p>
          }

           { this.renderForm() }
      </div>

    )
  }
}

export default Sign



// WEBPACK FOOTER //
// ./src/components/Sign.js